export default "__VITE_ASSET__aNMuISkw__"